import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { detailActionBtnStyle } from "../accountDetailTheme.js";
import { ServiceAccountKeyCell } from "./ServiceAccountKeyCell.jsx";
import { formatServiceAccountPermissions } from "../serviceAccountUtils.js";
import { schemaTableCell, schemaTableHeader } from "../../../components/ui/schemaTableStyles.js";

export function ServiceAccountList({ items, ap, saving, onEdit, onDelete, onRotate }) {
  const { c, dark, accentHex: A } = useThemeSlice();

  return (
    <div style={{ overflow: "auto", flex: 1 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ background: c.hover }}>
            <th style={schemaTableHeader(c, ap, { width: "16%" })}>Name</th>
            <th style={schemaTableHeader(c, ap, { width: "14%" })}>Permissions</th>
            <th style={schemaTableHeader(c, ap, { width: "22%" })}>Public key</th>
            <th style={schemaTableHeader(c, ap, { width: "22%" })}>Private key</th>
            <th style={schemaTableHeader(c, ap, { width: 110 })}>Last rotated</th>
            <th style={schemaTableHeader(c, ap, { width: 132, textAlign: "right" })}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => (
            <tr
              key={row.id}
              onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              style={{ transition: "background .15s ease" }}
            >
              <td style={schemaTableCell(c, { verticalAlign: "middle" })}>
                <div style={{ fontWeight: 700, color: c.text, fontSize: 13.5 }}>{row.name}</div>
              </td>
              <td style={schemaTableCell(c, { verticalAlign: "middle" })}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {formatServiceAccountPermissions(row.permissions).map((label) => (
                    <span key={label} style={permissionBadge(c, dark, A)}>
                      {label}
                    </span>
                  ))}
                </div>
              </td>
              <td style={schemaTableCell(c, { verticalAlign: "middle" })}>
                <ServiceAccountKeyCell value={row.publicKey} label="public key" />
              </td>
              <td style={schemaTableCell(c, { verticalAlign: "middle" })}>
                <ServiceAccountKeyCell value={row.privateKey} masked label="private key" />
              </td>
              <td style={{ ...schemaTableCell(c, { verticalAlign: "middle" }), color: c.sub, fontSize: 11.5 }}>
                {row.lastRotatedAt ? formatDate(row.lastRotatedAt) : "Never"}
              </td>
              <td style={{ ...schemaTableCell(c, { verticalAlign: "middle" }), textAlign: "right" }}>
                <div style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
                  <button type="button" onClick={() => onRotate(row)} disabled={saving} style={rotateBtn(c)} title="Rotate keys">
                    <RotateIcon />
                  </button>
                  <button type="button" aria-label={`Edit ${row.name}`} onClick={() => onEdit(row)} style={detailActionBtnStyle(ap)}>
                    {Ico.pencil}
                  </button>
                  <button type="button" aria-label={`Delete ${row.name}`} onClick={() => onDelete(row)} style={detailActionBtnStyle(ap, "danger")}>
                    {Ico.trash}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function permissionBadge(c, dark, A) {
  return {
    display: "inline-flex",
    alignItems: "center",
    height: 22,
    padding: "0 8px",
    borderRadius: 999,
    border: `1px solid ${dark ? `${A}44` : `${A}33`}`,
    background: dark ? `${A}18` : `${A}12`,
    color: dark ? c.text : A,
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.03em",
    textTransform: "uppercase",
  };
}

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "—";
  }
}

function rotateBtn(c) {
  return {
    width: 30,
    height: 30,
    borderRadius: 7,
    border: `1px solid ${c.cardBdr}`,
    background: c.card,
    color: c.mid,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };
}

function RotateIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
      <path d="M16 16h5v5" />
    </svg>
  );
}
